import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { defineMessages, intlShape, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';

import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';

import s from './EnhancedTableHead.scss';

const messages = defineMessages({
  sortTitle: {
    id: 'EnhancedTableHead.sortTitle',
    defaultMessage: 'Sort',
    description: 'Sort displayed in table head cells tooltip title',
  },
});

@withStyles(s)
@injectIntl
export default class EnhancedTableHead extends React.Component {
  static propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    columnData: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        tooltip: PropTypes.string,
        disablePadding: PropTypes.bool,
        numeric: PropTypes.bool,
        disableSorting: PropTypes.bool,
        cellClassName: PropTypes.string,
        minWidth: PropTypes.string,
        width: PropTypes.string,
      }),
    ).isRequired,
    loading: PropTypes.bool,
    classNameHead: PropTypes.string,
    classesNameRow: PropTypes.object, // eslint-disable-line
    classesSortLabel: PropTypes.object, // eslint-disable-line
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    classNameHead: '',
    classesNameRow: { root: s.tableHeadRow },
    classesSortLabel: {},
    loading: false,
  };

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {
      order,
      orderBy,
      columnData,
      classNameHead,
      classesNameRow,
      classesSortLabel,
      loading,
      intl: { formatMessage },
    } = this.props;

    return (
      <TableHead className={classNameHead}>
        <TableRow classes={classesNameRow}>
          {columnData.map(
            column => (
              <TableCell
                key={column.id}
                className={column.cellClassName}
                classes={{
                  root: s.generalStylesCell,
                }}
                align={column.numeric ? 'right' : 'inherit'}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={
                  !column.disableSorting && orderBy === column.id
                    ? order
                    : false
                }
                style={_.pickBy(
                  column,
                  (val, key) => ['minWidth', 'width'].includes(key) && val,
                )}
              >
                <Tooltip
                  title={
                    column.tooltip ||
                    (column.disableSorting
                      ? column.label
                      : formatMessage(messages.sortTitle))
                  }
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <div>
                    {column.disableSorting && !column.child && (
                      <TableSortLabel
                        id={column.id}
                        classes={{
                          root: s.disabled,
                        }}
                        active={false}
                        hideSortIcon
                      >
                        {column.label}
                      </TableSortLabel>
                    )}
                    {!column.disableSorting && !column.child && (
                      <TableSortLabel
                        data-test-id="vHo1LEDDQL83vALFCONfr"
                        id={column.id}
                        active={!loading && orderBy === column.id}
                        direction={order}
                        classes={{
                          ...classesSortLabel,
                          icon: classNames(classesSortLabel.icon, {
                            [s.hiddenSortIcon]:
                              loading || orderBy !== column.id,
                          }),
                        }}
                        onClick={
                          loading
                            ? () => null
                            : _.throttle(this.createSortHandler(column.id), 100)
                        }
                      >
                        {column.label}
                      </TableSortLabel>
                    )}
                    {column.child}
                  </div>
                </Tooltip>
              </TableCell>
            ),
            this,
          )}
        </TableRow>
      </TableHead>
    );
  }
}
